import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CreateCvSectionDateRequest,
  CvSectionDate,
  CvSectionDateResponse,
} from '@/../gen';

export const namespace = 'cvSectionDateNew';
const actionCreator = actionCreatorFactory(namespace);
export const SetCvSectionDate = actionCreator<CvSectionDateResponse>(
  'SET_CV_SECTION_DATE'
);
export const CreateCvSectionDate = actionCreator<{
  params: {
    cv_id: number;
  };
  body: CreateCvSectionDateRequest;
}>('CREATE_CV_SECTION_DATE');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionDate: CvSectionDate;
}

const initialState = (): State => {
  return { cvSectionDate: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(CreateCvSectionDate, async function(context, action) {
      const { data } = await this.proffApi.createCvSectionDate(
        action.payload.params.cv_id,
        action.payload.body
      );
      context.commit(SetCvSectionDate(data.data));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionDate, (state, action) => {
      state.cvSectionDate = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionDate: state => state.cvSectionDate,
  },
};
